export default __webpack_public_path__ + "static/media/hht2_ep12_speaking_03.fbbc09bb.png";